import { useEffect } from 'react';
import '@/types/gtag';

const CONSENT_KEY = 'cookie-consent';

// Helper function to read consent data directly from localStorage
const getConsentDataFromStorage = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    // Silent error handling
  }
  return null;
};

export function GoogleAnalytics() {
  useEffect(() => {
    const updateGAConsent = () => {
      const consentData = getConsentDataFromStorage();
      const hasAnalyticsConsent = consentData?.categories?.analytics === true;

      // Updating GA consent

      window.gtag('consent', 'update', {
        analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
        ad_storage: 'denied'
      });
    };

    // Update consent immediately
    updateGAConsent();

    // Listen for localStorage changes (from other tabs or direct changes)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === CONSENT_KEY) {
        updateGAConsent();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return null;
}
